export { formatPrice } from "@decocms/apps-commerce/sdk/formatPrice";

export type GenericValue<T> = T | GenericObject<T> | GenericArray<T>;
type GenericObject<T> = { [key: string]: GenericValue<T> };
type GenericArray<T> = Array<GenericValue<T>>;

export const removeProperties = <T>(
  obj: GenericValue<T>,
  propNames: string[],
): GenericValue<T> => {
  if (typeof obj !== "object" || obj === null) {
    return obj;
  }

  if (Array.isArray(obj)) {
    return obj.map((item) => removeProperties(item, propNames));
  }

  const newObj: GenericObject<T> = {};
  for (const [key, value] of Object.entries(obj as GenericObject<T>)) {
    if (typeof value === "object" && value !== null) {
      newObj[key] = removeProperties(value, propNames);
    } else {
      newObj[key] = value;
    }
  }

  propNames.forEach((propName) => {
    if (Object.prototype.hasOwnProperty.call(newObj, propName)) {
      delete newObj[propName];
    }
  });

  return newObj;
};

export const capitalizeFirstLetter = (str: string): string => {
  return str.charAt(0).toUpperCase() + str.slice(1).toLowerCase();
};

export const extractTitleFromPath = (pathname: string): string => {
  const lastSegment = pathname.split("/").filter(Boolean).at(-1) || "";
  const decoded = decodeURIComponent(lastSegment);
  const withSpaces = decoded.replace(/-+/g, " ");
  return capitalizeFirstLetter(withSpaces);
};
